import React from 'react'

export const SignUp = () => {
  return (
    <div>SignUp</div>
  )
}

